import Input from "@/components/Usados/InputField";
import Label from "@/components/Usados/Label";
import Button from "@/components/ui/button/Button";
import Alert from "@/components/ui/alert/Alert";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { apiFetch } from "@/service/api";

interface CreateRolProps {
  rol?: any;
  onSuccess?: () => void;
  onCancel?: () => void;
}

export default function CreateRol({
  rol,
  onSuccess,
  onCancel,
}: CreateRolProps) {
  const { id: proyecto_id } = useParams();
  const [form, setForm] = useState({
    nombre: "",
    descripcion: "",
    proyecto_id: Number(proyecto_id),
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const isEdit = !!rol;

  useEffect(() => {
    if (rol) {
      setForm({
        nombre: rol.nombre || "",
        descripcion: rol.descripcion || "",
        proyecto_id: Number(proyecto_id),
      });
    } else {
      resetForm();
    }
  }, [rol, proyecto_id]);

  const resetForm = () =>
    setForm({ nombre: "", descripcion: "", proyecto_id: Number(proyecto_id) });
  const handleCancel = () => {
    resetForm();
    if (onCancel) onCancel();
  };
  function handleChange(
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const url = isEdit
      ? `roles-proyectos/update/${rol.id}`
      : `roles-proyectos/create`;
    const method = isEdit ? "PATCH" : "POST";
    try {
      const response = await apiFetch(url, {
        method,
        body: JSON.stringify(form),
      });
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message ||
            `Error al ${isEdit ? "actualizar" : "crear"} rol`,
        );
      }
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
        if (onSuccess) onSuccess();
      }, 800);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <div className="min-h- rounded-2xl border border-gray-200 bg-white px-5 py-7 dark:border-gray-800 dark:bg-white/[0.03] xl:px-10 xl:py-12">
        <h3 className="mb-8 font-semibold text-gray-800 text-center text-theme-xl dark:text-white/90 sm:text-2xl">
          {isEdit ? "Editar Rol de Proyecto" : "Crear Nuevo Rol de Proyecto"}
        </h3>
        {error && <Alert variant="error" title="Error" message={error} />}
        {success && (
          <Alert
            variant="success"
            title="exito"
            message={`Rol ${isEdit ? "actualizado" : "creado"} correctamente`}
          />
        )}
        <form onSubmit={handleSubmit} className="space-y-6 max-w-2xl mx-auto">
          <div>
            <Label>Nombre del Rol</Label>
            <Input
              name="nombre"
              value={form.nombre}
              onChange={handleChange}
              required
              placeholder="Ej: Desarrollador Backend"
            />
          </div>
          <div>
            <Label>Descripcion</Label>
            <textarea
              name="descripcion"
              value={form.descripcion}
              onChange={handleChange}
              className="w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2 text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:text-white/90"
              rows={3}
              required
            />
          </div>
          <div className="flex justify-end gap-4 mt-8">
            {onCancel && (
              <Button
                variant="outline"
                onClick={handleCancel}
                disabled={loading}
              >
                Cancelar
              </Button>
            )}
            <Button type="submit" disabled={loading}>
              {loading
                ? isEdit
                  ? "Actualizando..."
                  : "Creando..."
                : isEdit
                ? "Actualizar Rol"
                : "Crear Rol"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
